import { addApolloState, initializeApollo } from "modules/apollo/apolloClient";
import ContentPagesNavigation from "modules/navigation/components/ContentPagesNavigation";
import ContactBar from "modules/layout/components/ContactBar";
import Header from "modules/layout/components/Header";
import Footer from "modules/layout/components/Footer";
import { navigationQueries } from "modules/ssgHelpers/sharedPageData";
import { findPageIdByFilePath } from "modules/common/utils/findPageIdByFilePath";
import { preFetchPageById } from "modules/navigation/hooks/useCMSPageById";
import { prefetchMenuTree } from "modules/layout/hooks/useNavigationMenus";
import findCurrentPageRouteTree from "modules/layout/utils/findCurrentPageRouteTree";
import LayoutRenderer from "modules/getcockpit/components/LayoutRenderer";
import ReleasesList from "modules/releases/components/ReleasesList";
import { preFetchReleases } from "modules/releases/hooks/useReleases";
import LocalizedHead from "modules/navigation/components/LocalizedHead";

const Releases = ({ currentPage, menuTree }) => {
  const currentPageNavigation = findCurrentPageRouteTree(
    menuTree || [],
    currentPage?._r,
  );
  const { data } = currentPage || {};

  return (
    <>
      <Header />
      <LocalizedHead
        fallbackTitle={currentPage?.title}
        routes={currentPage?._routes}
        {...currentPage}
      />
      <div className="container d-md-flex">
        <ContactBar />
        <ContentPagesNavigation currentPageNavigation={currentPageNavigation} />
        <div>
          {data?.layoutList?.before && (
            <LayoutRenderer layout={data.layoutList.before} />
          )}
          <ReleasesList />
          {data?.layoutList?.after && (
            <LayoutRenderer layout={data.layoutList.after} />
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export async function getStaticProps({ locale }) {
  if (locale === process.env.NEXT_PUBLIC_FAKE_LOCALE) {
    return {
      notFound: true,
    };
  }
  const apolloClient = initializeApollo(null, { locale });
  await navigationQueries(apolloClient, locale);

  const releasesPageId = findPageIdByFilePath("/releases/:slug");

  const currentPage = await preFetchPageById(apolloClient, {
    locale,
    pageId: releasesPageId,
  });
  const menuTree = await prefetchMenuTree(apolloClient, { locale });
  await preFetchReleases(apolloClient, { locale });

  return addApolloState(apolloClient, {
    props: { currentPage, menuTree },
    revalidate: 180,
  });
}
export default Releases;
